import { createQueryKeys } from "@lukemorales/query-key-factory";
import { http } from "src/axios";
import type {
  AssignedVcAccount,
  ServerUnassignedVcAccount,
  ServerVcAssignedAccount,
} from "src/pages/UserDashboard/VcAccountAssignments/vc-account-assignments-types";

export const vcAccountAssignments = createQueryKeys("vc-accounts", {
  assigned: {
    queryKey: null,
    queryFn: ({ signal }) => getVcAssignedAccounts(signal),
  },
  /** This query should never be cached. */
  unassigned: (storeCount: number) => ({
    // it makes no sense to cache unassigned accounts by store count
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: ["_"],
    queryFn: ({ signal }) => getVcUnassignedAccounts(storeCount, signal),
  }),
});

async function getVcAssignedAccounts(signal?: AbortSignal): Promise<AssignedVcAccount[]> {
  const response = await http.get<{ accounts: ServerVcAssignedAccount[] }>("/api/v2/vc/accounts/assigned", { signal });
  return response.data.accounts.map(account => ({
    id: account.ID,
    avcAccountCredentialsId: account.AVC_ACCOUNT_CREDENTIALS_ID,
    name: account.ACCOUNT_NAME,
    email: account.EMAIL,
    vendorName: account.VENDOR_NAME,
    storeName: account.STORE_NAME,
    partnerId: account.PARTNER_ID,
    notes: account.NOTES,
  }));
}

async function getVcUnassignedAccounts(storeCount: number, signal?: AbortSignal) {
  const response = await http.get<{ accounts: ServerUnassignedVcAccount[] }>("/api/v2/vc/accounts/unassigned", {
    signal,
    params: { store_count: storeCount },
  });
  return response.data.accounts.map(account => ({
    avcAccountCredentialsId: account.AVC_ACCOUNT_CREDENTIALS_ID,
    accountName: account.ACCOUNT_NAME,
    email: account.EMAIL,
  }));
}
